import axios from 'axios'
import appConfig from '@src/app.config'
import store from '@state/store'
import router from '@router'

function rewriteUrl(config) {
  if (
    config.baseURL.substr(config.baseURL.length - 6) === '/admin' &&
    config.url.substr(0, 4) === '/sms'
  ) {
    config.baseURL = config.baseURL.substr(0, config.baseURL.length - 6)
    config.url = `/sms/admin${config.url.substr(4, config.url.length)}`
  } else {
    config.baseURL =
      config.baseURL.substr(config.baseURL.length - 6) === '/admin'
        ? config.baseURL.substr(0, config.baseURL.length - 6)
        : config.baseURL
  }
  return config
}

const instance = axios.create({
  baseURL: appConfig.apiDomain,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

instance.interceptors.request.use(
  (config) => {
    let newConfig = rewriteUrl(config)
    return newConfig
  },
  (err) => {
    return Promise.reject(err)
  }
)

// Helper function to log errors to backend
function logErrorToBackend(error) {
  try {
    // Skip logging if this is already an error log request to prevent infinite loops
    if (error.config && error.config.url && error.config.url.includes('/error-log')) {
      return
    }

    const errorData = {
      message: error.message || 'Unknown error',
      error: (error.response && error.response.data && error.response.data.error) || 
             (error.response && error.response.data && error.response.data.message) || 
             error.toString(),
      stack: error.stack || '',
      url: window.location.href || '',
      userAgent: navigator.userAgent || '',
      timestamp: new Date().toISOString(),
      status: (error.response && error.response.status) || null,
      statusText: (error.response && error.response.statusText) || null,
      requestUrl: (error.config && error.config.url) || '',
      requestMethod: (error.config && error.config.method) || '',
    }

    // Send to backend error log endpoint (fire and forget)
    axios.post(`${appConfig.apiDomain}/error-log`, errorData, {
      timeout: 3000, // Short timeout to avoid blocking
    }).catch(() => {
      // Silently fail if error logging fails
    })
  } catch (e) {
    // Silently fail if error logging fails
  }
}

instance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  (error) => {
    // Log errors (500, network errors, etc.) to backend
    if (!error.response || error.response.status >= 500) {
      logErrorToBackend(error)
    }

    let notification = ''

    switch (error.response && error.response.status) {
      case 400:
        notification = {
          id: Date.now(),
          message: 'Invalied data! Please recheck your data.',
          type: 'error',
        }
        break
      case 403:
        notification = {
          id: Date.now(),
          message: 'Unauthorized or no permission',
          type: 'error',
        }
        break
      case 500:
        notification = {
          id: Date.now(),
          message: `${error.response.statusText}. Please contact customer support.`,
          type: 'error',
        }
        break
      case 401:
        store.dispatch('auth/logOut', {
          root: true,
        })
        router.push({ name: 'login' })

        break
      case 422:
        store.dispatch('auth/logOut', {
          root: true,
        })
        router.push({ name: 'login' })
    }

    if (notification)
      store.dispatch('notification/addNotification', notification, {
        root: true,
      })

    return Promise.reject(error)
  }
)
export default instance
